// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .container {
  width: 760px;
  position: relative;
}
:host .toolbox {
  float: right;
  line-height: 44px;
}
:host .toolbox button {
  /* margin-right: 8px; */
  margin-left: 10px;
}
:host ::ng-deep .input-text .mat-form-field-infix {
  padding-top: 5px;
  padding-bottom: 0px;
}
:host ::ng-deep .mat-dialog-container {
  display: inline-table !important;
}
:host ::ng-deep .mat-tab-label {
  height: 34px !important;
}
:host .mat-tab-container {
  min-height: 300px;
  height: 60vmin;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 15px;
}
:host .mat-tab-container > div {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/gauges/gauge-property/gauge-property.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/gauges/gauge-property/gauge-property.component.scss"],"names":[],"mappings":"AACE;EACE,YAAA;EACA,kBAAA;ACAJ;ADEE;EACI,YAAA;EACA,iBAAA;ACAN;ADGE;EACI,uBAAA;EACA,iBAAA;ACDN;ADIE;EACI,gBAAA;EACA,mBAAA;ACFN;ADKE;EACI,gCAAA;ACHN;ADME;EACE,uBAAA;ACJJ;ADOE;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;ACLJ;ADQE;EACE,cAAA;ACNJ","sourcesContent":[":host {\n  .container {\n    width: 760px;\n    position: relative;\n  }\n  .toolbox {\n      float: right;\n      line-height: 44px;\n  }\n\n  .toolbox button {\n      /* margin-right: 8px; */\n      margin-left: 10px;\n  }\n\n  ::ng-deep .input-text .mat-form-field-infix {\n      padding-top: 5px;\n      padding-bottom: 0px;\n  }\n\n  ::ng-deep .mat-dialog-container {\n      display: inline-table !important;\n  }\n\n  ::ng-deep .mat-tab-label {\n    height: 34px !important;\n  }\n\n  .mat-tab-container {\n    min-height:300px;\n    height:60vmin;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding-top: 15px;\n  }\n\n  .mat-tab-container > div {\n    display: block;\n  }\n}\n",":host .container {\n  width: 760px;\n  position: relative;\n}\n:host .toolbox {\n  float: right;\n  line-height: 44px;\n}\n:host .toolbox button {\n  /* margin-right: 8px; */\n  margin-left: 10px;\n}\n:host ::ng-deep .input-text .mat-form-field-infix {\n  padding-top: 5px;\n  padding-bottom: 0px;\n}\n:host ::ng-deep .mat-dialog-container {\n  display: inline-table !important;\n}\n:host ::ng-deep .mat-tab-label {\n  height: 34px !important;\n}\n:host .mat-tab-container {\n  min-height: 300px;\n  height: 60vmin;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-top: 15px;\n}\n:host .mat-tab-container > div {\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
